
@if (permissionsService.isUserInfoLoaded()) {
  <div class="tabbar show-tabbar" role="tablist" style="bottom: 0px;">
    <a #buttonHome class="tab-button has-icon icon-only"(click)="navigate('categories')" role="tab">
      <span class="app-icon tab-button-icon icon icon-md ion-md-home" role="img" aria-label="home"></span>
      <div class="button-effect"></div>
    </a>
    <ng-container *featureFlag="'flagEnableFilters'">
      @if (permissionsService.shouldShowFilters()) {
        <a #buttonFilters class="tab-button has-icon icon-only" (click)="navigate('filters')" role="tab">
          <span class="app-icon tab-button-icon icon icon-md ion-filter" role="img" aria-label="filters"></span>
          <div class="button-effect"></div>
        </a>
      }
    </ng-container>
    <a #buttonSettings class="tab-button has-icon icon-only" (click)="navigate('settings')" role="tab">
      <span class="app-icon tab-button-icon icon icon-md ion-md-contact" role="img" aria-label="contact"></span>
      <div class="button-effect"></div>
    </a>
    <div class="tab-highlight"></div>
  </div>
}
